/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModuleAccessScopeFilter } from './moduleAccessScopeFilter';


export interface ModuleAccessIncludeFilterItems { 
    relation?: ModuleAccessIncludeFilterItems.RelationEnum;
    scope?: ModuleAccessScopeFilter;
}
export namespace ModuleAccessIncludeFilterItems {
    export type RelationEnum = 'user' | 'company' | 'modulePermission';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        Company: 'company' as RelationEnum,
        ModulePermission: 'modulePermission' as RelationEnum
    };
}


